import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import api from '../../api';
import Button from '../button';
import Form from '../form';
import Input from '../input';
import Checkbox from '../checkbox';
import Loader from '../loader';
import './indexed-search-form.css';

const defaultIndexedSearch = {
  searchText: '',
  active: false,
};

const defaultErrors = {
  searchText: [],
  active: [],
};

const IndexedSearchForm = props => {
  const [indexedSearch, setIndexedSearch] = useState(defaultIndexedSearch);
  const [errors, setErrors] = useState(defaultErrors);
  const [isLoading, setIsLoading] = useState(props.id ? true : false);
  const [redirect, setRedirect] = useState('');

  const handleChange = e => {
    let value = e.target.value;

    setIndexedSearch({
      ...indexedSearch,
      [e.target.name]: value,
    });
    setErrors({
      ...errors,
      [e.target.name]: [],
    });
  };

  const handleSubmit = e => {
    const apiMethod = props.id ? api.indexedSearches.put : api.indexedSearches.post;
    const apiParams = props.id ? { id: props.id, indexedSearch } : { indexedSearch };

    e.preventDefault();
    setIsLoading(true);
    apiMethod(
      apiParams,
      () => {
        setRedirect('/recherches-indexees');
      },
      err => {
        if (err.response) {
          let newErrors = JSON.parse(JSON.stringify(defaultErrors));
          err.response.data.violations.map(error => {
            return newErrors[error.propertyPath].push(error.searchText);
          });
          setErrors(newErrors);
        } else {
          console.error(err);
        }
        setIsLoading(false);
      },
    );
  };

  useEffect(() => {
    if (props.id) {
      setIsLoading(true);
      api.indexedSearches.get(
        props.id,
        indexedSearch => {
          let newIndexedSearch = {
            ...defaultIndexedSearch,
            ...indexedSearch,
            imageId: indexedSearch.image ? indexedSearch.image.id : null,
          };

          setIndexedSearch(newIndexedSearch);
          setIsLoading(false);
        },
      );
    } else {
      setIndexedSearch(defaultIndexedSearch);
    }
  }, [props.id]);

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="indexed-search-form">
      <Form
        className="indexed-search-form_form"
        onSubmit={handleSubmit}
      >
        <div className="indexed-search-form_column">
          <Input
            errors={errors.searchText}
            label="Texte"
            name="searchText"
            onChange={handleChange}
            type="text"
            value={indexedSearch.searchText}
          />

          <Checkbox
            errors={errors.active}
            label="Actif"
            name="active"
            onChange={handleChange}
            style={{width: '100%', marginRight: '10px'}}
            value={indexedSearch.active}
          />

          <Button
            className="indexed-search-form_submit-button"
            label={`${props.id ? 'Modifier' : 'Créer'} le lien`}
            theme="success"
            type="submit"
          />
        </div>
      </Form>
    </div>
  );
};

IndexedSearchForm.propTypes = {
  id: PropTypes.number,
};

export default IndexedSearchForm;
